import React from 'react';
import { GradientInfoCardStyled } from './GradientInfoCard.styled';

interface IGradientInfoCardProps {
	children?: React.ReactNode;
	className?: string;
}

export const GradientInfoCard = (props: IGradientInfoCardProps) => {
	const { children, className } = props;

	return (
		<GradientInfoCardStyled className={className}>
			{children}
		</GradientInfoCardStyled>
	);
};
